import { useEffect, useState } from 'react';

import useLossAndDamageClaimStatusList from '../../../redux/hooks/useLossAndDamageClaimStatusList';
import FormSelectBox from '../Inputs/FormSelectBox';

const LossAndDamageClaimStatusSelector = ({
  placeholder = 'Select Status',
  label = 'Status',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  className = '',
  tabIndex,
  disableValidation = false,
  mode,
}) => {
  const [options, setOptions] = useState([]);
  const statusList = useLossAndDamageClaimStatusList();

  useEffect(() => {
    if (statusList?.length >= 0) {
      const options = statusList.map((row) => ({
        label: row.claimStatusDescription,
        value: row.claimStatusCode,
      }));
      setOptions(options);
    } else {
      setOptions([]);
    }
  }, [statusList]);

  return (
    <FormSelectBox
      loading={statusList === undefined}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
      mode={mode}
    />
  );
};

export default LossAndDamageClaimStatusSelector;
